import { render, staticRenderFns } from "./UserRetrievePass.vue?vue&type=template&id=331c2358&scoped=true"
import script from "./UserRetrievePass.vue?vue&type=script&lang=js"
export * from "./UserRetrievePass.vue?vue&type=script&lang=js"
import style0 from "./UserRetrievePass.vue?vue&type=style&index=0&id=331c2358&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331c2358",
  null
  
)

export default component.exports